export default __webpack_public_path__ + "static/F&FIngredients-7118f1d12f82e83193f29568fb3e40b9.png";